import { FC, useState } from "react";
import { pathOr } from "ramda";

import LikeButton from "./LikeButton";

interface ImageShowCaseProps {
  shots: { src: string; alt?: string }[]; // Changed to use src string instead of StaticImageData
}

const ImageShowCase: FC<ImageShowCaseProps> = ({ shots }) => {
  const [activeImageIndex, setActiveImageIndex] = useState(0);

  return (
    <div className="space-y-3 rounded-2xl border border-neutral-300 p-2">
      <div className="relative overflow-hidden rounded-2xl md:h-[520px]">
        <LikeButton className="absolute right-5 top-5" />
        <img
          src={pathOr("", [activeImageIndex, "src"], shots)}
          alt={pathOr("shoe image", [activeImageIndex, "alt"], shots)}
          className="size-full object-cover object-center"
        />
      </div>
      <div className="grid grid-cols-4 gap-3">
        {shots.map((shot, index) => (
          <div
            key={shot.src}
            className={`${
              activeImageIndex === index ? "border-2 border-primary" : ""
            } h-[100px] overflow-hidden rounded-lg`}
          >
            <button
              className="size-full"
              type="button"
              onClick={() => setActiveImageIndex(index)}
            >
              <img
                src={shot.src}
                alt={shot.alt || "shoe image"}
                className="size-full object-cover object-center"
              />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageShowCase;
